import { observer } from 'mobx-react-lite'
import { CheckboxInputContainer } from '@/components/inputs/CheckboxInputContainer'
import { type CompleteInfoGatheringDialogViewModel } from '@/features/jobs/details/components/InfoGatheringCard/CompleteInfoGatheringDialog/CompleteInfoGatheringDialogViewModel'
import { CompleteInfoGatheringDialog } from '@/features/jobs/details/components/InfoGatheringCard/CompleteInfoGatheringDialog'

export interface CompleteInfoGatheringDialogContainerProps {
  vm: CompleteInfoGatheringDialogViewModel
  /**
   * Whether to offer bypassing the required items.
   */
  isAdmin: boolean
  requestedProName?: string
}

export const CompleteInfoGatheringDialogContainer = observer(
  function CompleteInfoGatheringDialogContainer({
    vm,
    isAdmin,
    requestedProName,
  }: CompleteInfoGatheringDialogContainerProps) {
    return (
      <CompleteInfoGatheringDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onComplete={vm.complete}
        isCompletePending={vm.complete.pending}
        requestedProName={requestedProName}
        completeAsAdminInput={
          isAdmin && (
            <CheckboxInputContainer
              model={vm}
              field="completeAsAdmin"
              label="Bypass required items as Admin"
              testId="complete-info-gathering-dialog-complete-as-admin-input"
            />
          )
        }
      />
    )
  },
)
